export const INITIALIZE_FORM_FIELD = '@@custom-redux-form/INITIALIZE_FORM_FIELD';
export const INITIALIZE_FORM_FIELDS = '@@custom-redux-form/INITIALIZE_FORM_FIELDS';
export const CLEAR_SUBMIT_ERROR = '@@custom-redux-form/CLEAR_SUBMIT_ERROR';
